/* eslint-disable no-alert, no-console */
/* eslint-disable */

import React from 'react';
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
} from 'react-router-dom';
import SignIn from '../pages/signin/SignIn';
import SignUp from '../pages/signup/SignUp';
import EulaScreen from '../pages/eula/EulaScreen';
import CheckPassword from '../pages/check-password/CheckPassword';
import VerifyAccount from '../pages/verify-email/VerifyAccount';
import ForgotPasswordEmail from '../pages/forgot-password/ForgotPasswordEmail';
import RegisterComplete from '../pages/register-complete/RegisterComplete';
import { AuthPAGES, ExternalPAGES } from '../constants/pages';
import VerifyPhone from '../pages/verify-phone/VerifyPhone';
import Pin from '../pages/pin/pin';
import logo from '../assets/logo.png';
import { backgroundStyle } from '../pages/styles';
import EmailSent from '../pages/email-sent/EmailSent';
import AdditionalInfo from '../pages/additional-info/AdditionalInfo';
import MobileDocusignBaa from '../pages/mobile-docusign-baa/MobileDocusignBaa';

const AuthStackNavigation: React.FC = () => {
  return (
    <div style={backgroundStyle}>
      <img
        src={logo}
        alt='GaleAI'
        style={{ marginBottom: '24px', width: '140px' }}
      />
      <img
        src='/icons/icon-192x192.png'
        width='64px'
        height='64px'
        alt='GaleAI Icon'
        style={{ marginBottom: '24px' }}
      />
      <Router>
        <Routes>
          {/* <Route path={AuthPAGES.baseUrl} element={<SignIn />} /> */}
          <Route path={AuthPAGES.signIn} element={<SignIn />} />
          <Route path={AuthPAGES.signUp} element={<SignUp />} />
          <Route path={AuthPAGES.eula} element={<EulaScreen />} />
          <Route path={AuthPAGES.verifyEmail} element={<VerifyAccount />} />
          <Route path={AuthPAGES.additionalInfo} element={<AdditionalInfo />} />
          <Route
            path={AuthPAGES.registerComplete}
            element={<RegisterComplete />}
          />
          <Route
            path={AuthPAGES.forgotPassword}
            element={<ForgotPasswordEmail />}
          />
          <Route
            path={`${AuthPAGES.checkPassword}/:type`}
            element={<CheckPassword />}
          />
          <Route path={AuthPAGES.pin} element={<Pin />} />
          <Route path={`${AuthPAGES.verifyPhone}`} element={<VerifyPhone />} />
          <Route path={`${AuthPAGES.emailSent}`} element={<EmailSent />} />
          <Route
            path={ExternalPAGES.mobileDocusignBAA}
            element={<MobileDocusignBaa />}
          />
          <Route
            path='*'
            element={<Navigate to={AuthPAGES.signIn} replace />}
          />
        </Routes>
      </Router>
    </div>
  );
};

export default AuthStackNavigation;
